module.exports = __webpack_public_path__ + "img/744eb4f.jpg";